module.exports = __webpack_public_path__ + "static/media/DSC_2905.0d6ab03b.jpg";